/**
 * Shared form option lists — single source for the funding-category catalogue
 * and the US state list (previously copy-pasted in Onboard.jsx and
 * Preferences.jsx, where the category labels had already drifted apart).
 *
 * FOCUS_AREA_OPTIONS mirrors backend/constants.py CATEGORY_LABELS — keep the
 * codes and labels in sync with it.
 */

export const FOCUS_AREA_OPTIONS = [
  { code: 'ED',  label: 'Education' },
  { code: 'HL',  label: 'Health' },
  { code: 'CD',  label: 'Community Development' },
  { code: 'HO',  label: 'Housing' },
  { code: 'ISS', label: 'Income Security & Social Services' },
  { code: 'ELT', label: 'Employment & Workforce' },
  { code: 'ENV', label: 'Environment' },
  { code: 'FN',  label: 'Food & Nutrition' },
  { code: 'AR',  label: 'Arts & Humanities' },
  { code: 'HU',  label: 'Humanities' },
  { code: 'LJL', label: 'Law, Justice & Legal Services' },
  { code: 'NR',  label: 'Natural Resources' },
  { code: 'ST',  label: 'Science & Technology' },
  { code: 'DPR', label: 'Disaster Prevention & Relief' },
  { code: 'AG',  label: 'Agriculture' },
  { code: 'RD',  label: 'Regional Development' },
  { code: 'T',   label: 'Transportation' },
  { code: 'EN',  label: 'Energy' },
  { code: 'CP',  label: 'Consumer Protection' },
  { code: 'BC',  label: 'Business & Commerce' },
  { code: 'O',   label: 'Other' },
]

export const US_STATES = [
  'AL','AK','AZ','AR','CA','CO','CT','DE','FL','GA','HI','ID','IL','IN',
  'IA','KS','KY','LA','ME','MD','MA','MI','MN','MS','MO','MT','NE','NV',
  'NH','NJ','NM','NY','NC','ND','OH','OK','OR','PA','RI','SC','SD','TN',
  'TX','UT','VT','VA','WA','WV','WI','WY','DC',
]
